import React, {useRef, useState} from "react";
import axios from "axios";
import {ROOT_URL} from "../../../config/url";
import {
  getErrorMessageByKey,
  Input,
  jsonFormatText,
  Modal,
  Select,
  Textarea,
  useList,
  useNotification,
  useObject,
} from "@vokymlak/kabinet-ui";
import moment from "moment";
import ModalCowParentSelect from "./ModalCowParentSelect";

function ModalCowEdit(props) {
  const [isDropped, setIsDropped] = useState(false);

  const inputDate = useRef(null);
  const inputName = useRef(null);
  const inputChipCode = useRef(null);
  const inputUnmCode = useRef(null);
  const inputNote = useRef(null);
  const inputWeightWeight = useRef(null);
  const inputCowGenderTypeTag = useRef(null);
  const inputCowLocationUuid = useRef(null);

  const inputDroppedDate = useRef(null);
  const inputDroppedNote = useRef(null);


  const [selectParentFe, setSelectParentFe] = useState(null)
  const [isModalSelectParentFe, setIsModalSelectParentFe] = useState(false)

  const [selectParentMa, setSelectParentMa] = useState(null)
  const [isModalSelectParentMa, setIsModalSelectParentMa] = useState(false)

  const {
    list: [locations],
  } = useList({apiUrl: "/api/cow-locations", rootUrl: ROOT_URL});

  const {
    object: [object],
  } = useObject({
    apiUrl: "api/cow/" + props.object.uuid,
    rootUrl: ROOT_URL,
    callbackResponse: response => {
      if (!!response) {
        setSelectParentFe((!!response.parent_fe && response.parent_fe) || null);
        setSelectParentMa((!!response.parent_ma && response.parent_ma) || null);
        setIsDropped(!!response.dropped_at);
      }
    },
    callbackError: () => {
      props.handleClose();
    },
  });


  const [isDelete, setIsDelete] = useState(false);

  const {notification} = useNotification();

  const numberConvertV = (numberString) => {
    return !!numberString && numberString.length > 0
      ? Number(String(Number(numberString).toFixed(3)))
      : null;
  };

  const changeEdit = () => {
    const date = jsonFormatText(inputDate.current.value);
    const name = jsonFormatText(inputName.current.value);
    const chipCode = jsonFormatText(inputChipCode.current.value);
    const unmCode = jsonFormatText(inputUnmCode.current.value);
    const note = jsonFormatText(inputNote.current.value);
    const weight = inputWeightWeight.current.value;
    const cowLocationUuid = inputCowLocationUuid.current.value;
    let cowGenderTypeTag = inputCowGenderTypeTag.current.value;
    cowGenderTypeTag = cowGenderTypeTag.length > 0
      ? cowGenderTypeTag === "null"
        ? null
        : cowGenderTypeTag
      : null

    let droppedDate = null;
    let droppedNote = null;

    // if ((!cowGenderTypeTag
    //     || (!!cowGenderTypeTag && cowGenderTypeTag === "null"))
    //   || isValidateNullText(date)
    //   || isValidateNullText(name)) {
    //   notification("Заполните все обязательные поля", "red");
    //   return;
    // }

    if (isDropped) {
      droppedDate = jsonFormatText(inputDroppedDate.current.value);
      droppedNote = jsonFormatText(inputDroppedNote.current.value);
    }

    const jsonData = JSON.stringify({
      is_dropped: isDropped,
      dropped_at: droppedDate,
      dropped_out_due: droppedNote,
      name: name,
      chip_code: chipCode,
      unm_code: unmCode,
      note: note,
      birthdate: date,
      weight: numberConvertV(weight),
      cow_type: !!cowGenderTypeTag ? {
        tag: cowGenderTypeTag,
      } : null,
      parent_ma: !!selectParentMa ? {
        uuid: selectParentMa.uuid,
      } : null,
      parent_fe: !!selectParentFe ? {
        uuid: selectParentFe.uuid,
      } : null,
      cow_location:
        cowLocationUuid.length > 0
          ? cowLocationUuid === "null"
            ? null
            : {
              uuid: cowLocationUuid,
            }
          : null,
    });

    axios
      .put("/api/cow/" + props.object.uuid + "/edit", jsonData, {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Данные сохранены", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const changeDelete = (event) => {
    event.preventDefault();

    axios
      .delete("api/cow/" + props.object.uuid + "/delete", {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("КРС удалён", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const selectOptions = () => {
    return [{
      value: "null",
      title: "Не выбран",
    },
      {
        value: "BULL",
        title: "Бык-производитель",
      },
      {
        value: "COW",
        title: "Корова",
      },
      {
        value: "NETEL",
        title: "Нетель",
      },
      {
        value: "HEIFER",
        title: "Телка",
      },
      {
        value: "STEER",
        title: "Бычок",
      }
    ];
  };

  const getSelectLocationOptions = (list) => {
    const options = [
      {
        value: "null",
        title: "Не выбрано",
      },
    ];

    list.map((type) => {
      const option = {
        value: type.uuid,
        title: type.title,
      };

      options.push(option);
    });

    return options;
  };

  return (
    !!object && !!locations && (
      <>
        <Modal handleClose={() => props.handleClose()}>
          {!isDelete && (
            <div className="Form">
              <div
                className="Form__title"
                style={{fontSize: 19, fontWeight: 700}}
              >
                {!!object.name && object.name}({object.id})&nbsp;-&nbsp;{!!object.birthdate && moment(object.birthdate.substring(0, 19)).format("DD.MM.YYYY")}
                <div className="Text__signature">КРС</div>
              </div>

              <div className="Form__field">
                <Input reference={inputName} label="Код КРС (имя / номер бирки)"
                       value={!!object.name && object.name}/>
              </div>

              <div className="Form__field">
                <Input reference={inputChipCode} label="Код с чипа"
                       value={!!object.chip_code && object.chip_code}/>
              </div>

              <div className="Form__field">
                <Input reference={inputUnmCode} label="УНСМ номер"
                       value={!!object.unm_code && object.unm_code}/>
              </div>

              <div className="Form__field">
                <Textarea reference={inputNote} label="Примечание"
                          value={!!object.note && object.note}/>
              </div>

              <div className="Form__field">
                <Input reference={inputDate} type={'date'} isFixed={true} label="Дата рождения"
                       value={
                         !!object.birthdate
                           ? moment(object.birthdate.substring(0, 19)).format(
                             "YYYY-MM-DD"
                           )
                           : null
                       }/>
              </div>


              <div className="Form__field">
                <Input type={'number'} reference={inputWeightWeight} label="Живая масса (кг)"
                       value={!!object.weight && (object.weight / 1000).toFixed(3)}/>
              </div>

              <div className="Form__field">
                <Select
                  isFixed={true}
                  reference={inputCowGenderTypeTag}
                  options={selectOptions()}
                  label="Половозрастная группа"
                  value={!!object.cow_type && object.cow_type.tag}
                />
              </div>

              {!selectParentMa && (
                <div className="Form__field"
                     style={{
                       cursor: "pointer"
                     }}
                     onClick={() => setIsModalSelectParentMa(true)}>
                  <div className="Field__label">
                    КРС папа
                  </div>
                  <div className="Field__text">
                    -
                  </div>
                </div>
              )}

              {!!selectParentMa && (
                <div className="Form__field"
                     style={{
                       cursor: "pointer"
                     }}
                     onClick={() => setIsModalSelectParentMa(true)}>
                  <div className="Field__label">
                    КРС папа
                  </div>
                  <div className="Field__text">
                    {!!selectParentMa.name && selectParentMa.name}({selectParentMa.id})
                    &nbsp;-&nbsp;{!!selectParentMa.birthdate && moment(selectParentMa.birthdate.substring(0, 19)).format("DD.MM.YYYY")}
                  </div>
                </div>
              )}

              {!selectParentFe && (
                <div className="Form__field"
                     style={{
                       cursor: "pointer"
                     }}
                     onClick={() => setIsModalSelectParentFe(true)}>
                  <div className="Field__label">
                    КРС мама
                  </div>
                  <div className="Field__text">
                    -
                  </div>
                </div>
              )}

              {!!selectParentFe && (
                <div className="Form__field"
                     style={{
                       cursor: "pointer"
                     }}
                     onClick={() => setIsModalSelectParentFe(true)}>
                  <div className="Field__label">
                    КРС мама
                  </div>
                  <div className="Field__text">
                    {!!selectParentFe.name && selectParentFe.name}({selectParentFe.id})
                    &nbsp;-&nbsp;{!!selectParentFe.birthdate && moment(selectParentFe.birthdate.substring(0, 19)).format("DD.MM.YYYY")}
                  </div>
                </div>
              )}

              <div className="Form__field">
                <Select
                  isFixed={true}
                  reference={inputCowLocationUuid}
                  options={!!locations && getSelectLocationOptions(locations)}
                  value={!!object.cow_location ? object.cow_location.uuid : null}
                  label="Локация"
                />
              </div>

              <div className="Form__field">
                <div
                  className="Button__swith"
                  style={{
                    padding: "8px",
                    width: "100%",
                    border: isDropped ? "2px solid #ff000033" : "2px dashed #20202015",
                    backgroundColor: isDropped ? "#ff000033" : "#ffffff",
                    borderRadius: 6,
                    marginTop: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsDropped(!isDropped)}
                >
                  <div
                    className="Swith__text"
                    style={{
                      fontSize: 17,
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Выбыл
                  </div>
                  <div
                    className={
                      "Swith Swith_gray" +
                      ((isDropped && " Swith_active Swith_active_gray") || "")
                    }
                  ></div>
                </div>
              </div>

              {isDropped && (
                <div className="Form__field">
                  <Input reference={inputDroppedDate} type={'date'} isFixed={true} label="Дата выбывания *"
                         value={(!!object.dropped_at && object.dropped_at.substring(0, 10)) || moment().format("YYYY-MM-DD")}/>
                </div>
              )}

              {isDropped && (
                <div className="Form__field">
                  <Input reference={inputDroppedNote} label="Причина выбывания"
                         value={!!object.dropped_out_due && object.dropped_out_due}/>
                </div>
              )}

              <div className="Form__actions Form__actions_center">
                <button className="Action__button Action__button_all Action__button_blue"
                        onClick={() => changeEdit()}>
                  Применить
                </button>
              </div>

              <div className="Form__actions Form__actions_center">
                <div
                  className="Action__link Action__link_red"
                  onClick={() => setIsDelete(true)}
                >
                  Удалить
                </div>
              </div>
            </div>
          )}
          {isDelete && (
            <form className="Form" onSubmit={(event) => changeDelete(event)}>
              <div
                className="Form__title"
                style={{fontSize: 19, fontWeight: 700}}
              >
                {!!object.name && object.name}({object.id})&nbsp;-&nbsp;{!!object.birthdate && moment(object.birthdate.substring(0, 19)).format("DD.MM.YYYY")}
                <div className="Text__signature">Удалить</div>
              </div>

              <div className="Form__actions Form__actions_center">
                <button className="Action__button Action__button_all Action__button_red">
                  Удалить
                </button>
              </div>

              <div className="Form__actions Form__actions_center">
                <div className="Action__link" onClick={() => setIsDelete(false)}>
                  Отмена
                </div>
              </div>
            </form>
          )}
        </Modal>

        {isModalSelectParentMa && (
          <ModalCowParentSelect
            item={selectParentMa}
            typeTag={"MALE"}
            successfulRequest={item =>
              setSelectParentMa(item)
            }
            handleClose={() => setIsModalSelectParentMa(false)}
          />
        )}

        {isModalSelectParentFe && (
          <ModalCowParentSelect
            item={selectParentFe}
            typeTag={"FEMALE"}
            successfulRequest={item =>
              setSelectParentFe(item)
            }
            handleClose={() => setIsModalSelectParentFe(false)}
          />
        )}
      </>
    )
  );
}

export default ModalCowEdit;
